import { Injectable } from "@angular/core";
import { ProductDataModel4, ItemTagViewModel, RecipeLinkingDataModel, ProductViewModel, RecipelinkingViewModel, ScheduledForRequest, WebshopSettingsDataModel2, MenuSettings_SortType } from "../../shared/models";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { ContentType, SortDirection } from "../../shared/contentTypes";
import { CoreLogService } from "../../services/log.service";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";
import { WebShopService } from "../../services/webShop.service";
import { ProductService } from "../../services/product.service";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { Observable } from "rxjs";
import { IProductViewModel } from "../../shared/models/product.facade";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";


@Injectable()
export class RecipeLinkService {
  private recipeLinkingObsServ: IObjectObserver<RecipeLinkingDataModel>;
  constructor(private _objObsInjectHelper: CircularInjectionHelper
    , private _coreLogService: CoreLogService
    , private _productService: ProductService
    , private _webshopService: WebShopService
    , private _coreLanguageService: CoreLanguageService) {
    const me = this;
    this.recipeLinkingObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<RecipeLinkingDataModel>(ContentType.RecipeLinking, this._objObsInjectHelper);
  }

  public get ObserveChanges(): Observable<void> {
    return this._productService.ProductChanges;
  }

  public GetRecipeLinking(locationId: number, id: number, itemTags: ItemTagViewModel[] = null, likeIds: number[], dislikeIds: number[]): Promise<RecipelinkingViewModel> {
    const me = this;
    return new Promise<RecipelinkingViewModel>(async (resolve, reject) => {
      try {
        const webshopSettings = await me._webshopService.getWebshopSettingsDataModel();
        const menuSettings = await me._webshopService.getMenuSettings();
        const schedule_req = new ScheduledForRequest(me._webshopService.getScheduledForReferenceTime(), locationId, webshopSettings, me._coreLanguageService);
        const recipeLinking = await me.recipeLinkingObsServ.GetObject(id);
        const subProductIDs = recipeLinking.products.map(product => product.product_id);
        const recipe_products = await me._productService.GetProductsByFilter(locationId, me._webshopService.sortiment,
          model => !model.deleted
            && model.saleable
            && !model.isScheduledFor(schedule_req).hide
            && subProductIDs.includes(model.product_id)
        );
        const view_products = me.mapRecipeProductsToProductViewModelList(locationId, recipe_products, itemTags, likeIds, schedule_req);
        const sortFunction = me.getSortFunction(menuSettings.sort_type);
        const view_recipeLinking = me.mapToRecipeLinkingViewModel(locationId, recipeLinking, likeIds, dislikeIds, view_products, sortFunction);
        resolve(view_recipeLinking)
      } catch (error) {
        me._coreLogService.error("RecipeLinkService.GetProducts", "GetObjectsByFilter", "GetObject", error);
        reject();
      }
    });
  }

  private getSortFunction(sortType: MenuSettings_SortType): (a: IProductViewModel, b: IProductViewModel) => number {
    const sortOptions: SortOption[] = [];
    const pagingHelper = new PagingHelper();

    sortOptions.push(pagingHelper.createSortOption("amountOfLikedTags", SortDirection.DESC));

    if (sortType === MenuSettings_SortType.FreeItemnumber) {
      sortOptions.push(pagingHelper.createSortOption("free_item_nr", SortDirection.ASC));
    } else if (sortType === MenuSettings_SortType.Alphabetic) {
      sortOptions.push(pagingHelper.createSortOption("label", SortDirection.ASC));
    }
    // Immer als Fallback
    sortOptions.push(pagingHelper.createSortOption("artikelNo", SortDirection.ASC));

    return pagingHelper.fieldSorter(sortOptions);
  }

  // mapping
  private mapRecipeProductsToProductViewModelList(locationId: number, modelList: ProductDataModel4[], itemTags: ItemTagViewModel[], likeIds: number[], schedule_req: ScheduledForRequest): ProductViewModel[] {
    const me = this;
    if (modelList) {
      const result: ProductViewModel[] = [];
      modelList.forEach(model => {
        result.push(new ProductViewModel(locationId, model, itemTags, likeIds, schedule_req));
      });
      return result;
    } else {
      return null;
    }
  }

  //mapping
  private mapToRecipeLinkingViewModel(locationId: number, model: RecipeLinkingDataModel, likeIds: number[], dislikeIds: number[], products: ProductViewModel[], sortFunction: (a: IProductViewModel, b: IProductViewModel) => number): RecipelinkingViewModel {
    const me = this;
    if (model) {
      const viewModel = new RecipelinkingViewModel(locationId, model, likeIds, dislikeIds, products, sortFunction);
      return viewModel;
    } else {
      return null;
    }
  }
}
